<template>
    <div>
        <UtilsContent @close-action="closeHighlight">
            <template v-slot:header>
                <div class="d-flex flex-row justify-start align-center mx-3 mb-4">
                    <img :src="indexImg" class="img-index mr-2" alt="" />
                    <span class="text-h5 ma-0 primary--text">
                        {{ $t('bookReading.marker') }}
                    </span>
                </div>
            </template>
            <template v-slot:content>
                <div>
                    <v-row class="d-flex justify-center align-center flex-row">
                        <v-col cols="3" v-for="(type, index) of highlightTypes" :key="index">
                            <HighlightTypeItem
                                :active="selectType === type.id"
                                :value="type.value"
                                :img="type.img"
                                :type_id="type.id"
                                @select="setSelectedType(type.id)"
                            />
                        </v-col>
                    </v-row>
                    <div
                        class="mt-4 d-flex flex-column chapters-container"
                        id="chapter-container"
                        v-if="highlightFiltered.length"
                    >
                        <HighlightItem
                            v-for="(hlg, index) of highlightFiltered"
                            :key="index"
                            :marker_data="hlg"
                            :value="index"
                        />
                    </div>
                    <div class="mt-4 d-flex flex-column chapters-container" v-else>
                        <span class="text-h6 text-center">
                            {{ $t('bookReading.without_highlights') }}
                        </span>
                    </div>
                </div>
            </template>
            <template v-slot:actions>
                <v-btn
                    color="#95afad"
                    fab
                    small
                    dark
                    class="mt-5 text--white"
                    @click="downScroll"
                    v-if="highlightFiltered.length"
                >
                    <v-icon dark class="text--white">mdi-arrow-down</v-icon>
                </v-btn>
            </template>
        </UtilsContent>
    </div>
</template>
<script>
/* eslint-disable global-require */
import { mapState } from 'vuex'

import UtilsContent from '@/components/core/utils/UtilsContent.vue'
import HighlightItem from './items/HighlightItem.vue'
import HighlightTypeItem from './items/HighlightTypeItem.vue'

export default {
    components: {
        UtilsContent,
        HighlightItem,
        HighlightTypeItem,
    },
    computed: {
        ...mapState({
            bookHighlightData: (state) => state.bookReading.bookHighlightData,
            currentChapter: (state) => state.bookReading.currentChapter,
        }),
        highlightFiltered() {
            const vm = this
            return this.bookHighlightData.filter((el) => el.ordinalHighlightType === vm.selectType)
        },
    },
    data() {
        return {
            indexImg: require('@/assets/img/icons/reading/icon-highlightings-2.svg'),
            scrollPos: 0,
            selectType: 0,
            highlightTypes: [
                {
                    id: 0,
                    value: this.$t('bookReading.characters'),
                    color: '#97ed57',
                    img: require('@/assets/img/icons/reading/highlight/icon-personajes.svg'),
                },
                {
                    id: 1,
                    value: this.$t('bookReading.actions'),
                    color: '#57d6ed',
                    img: require('@/assets/img/icons/reading/highlight/icon-acciones.svg'),
                },
                {
                    id: 2,
                    value: this.$t('bookReading.vocabulary'),
                    color: '#ffdb39',
                    img: require('@/assets/img/icons/reading/highlight/icon-vocabulario.svg'),
                },
                {
                    id: 3,
                    value: this.$t('bookReading.places'),
                    color: '#ff44b9',
                    img: require('@/assets/img/icons/reading/highlight/icon-lugares.svg'),
                },
            ],
        }
    },
    methods: {
        downScroll() {
            const el = document.getElementById('chapter-container')
            el.scrollTop += 10
        },
        closeHighlight() {
            this.$emit('close-highlight')
        },
        setSelectedType(value) {
            this.selectType = value
        },
    },
}
</script>
<style>
.chapters-container {
    height: 35vh;
    max-height: 35vh;
    overflow: auto;
}
</style>
